import React, { useEffect, useState } from "react";
import { Spinner, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { createAbout, updateAbout } from "../../services/Admin/adminServices";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const AboutForm = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { info, isEditMode } = location.state || {};
  const [uploadingImage, setUploadingImage] = useState(false);
  const [imagePreview, setImagePreview] = useState(info?.image || null);
  const [imageFile, setImageFile] = useState(null);
  useEffect(() => {
    if (!location.state) {
      navigate("/admin/about");
    }
  }, []);

  const validationSchema = Yup.object({
    aboutUs: Yup.string().required("aboutUs is required"),
  });

  const initialValues = isEditMode
    ? {
        aboutUs: info,
      }
    : {
        aboutUs: "",
      };

  const uploadImageToS3 = async (file) => {
    if (!file) return null;

    setUploadingImage(true);
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch("/api/admin/uploadImage", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Image upload failed");
      }

      const data = await response.json();
      return data.image || data.url;
    } catch (error) {
      console.error("Error uploading image:", error);
      toast.error("Failed to upload image");
      return null;
    } finally {
      setUploadingImage(false);
    }
  };
  const handleImageChange = async (e, setFieldValue) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith("image/")) {
        toast.error("Please select a valid image file");
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        toast.error("Image size must be less than 5MB");
        return;
      }

      setImageFile(file);

      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);

      const imageUrl = await uploadImageToS3(file);
      if (imageUrl) {
        setFieldValue("image", imageUrl);
        toast.success("Image uploaded successfully");
      }
    }
  };

  // Clear image preview and URL
  const handleClearImage = (setFieldValue) => {
    setImagePreview(null);
    setImageFile(null);
    setFieldValue("image", "");
  };

  const handleSubmit = async (values) => {
    try {
      if (isEditMode) {
        await updateAbout(values);
        toast.success("Updated successfully");
      } else {
        await updateAbout(values);
        toast.success("Created successfully");
      }
      navigate("/about");
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 style={{ color: "#E5484D" }}>
          {isEditMode ? "Edit About Us" : "Add New About"}
        </h2>

        <Button variant="secondary" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div className="card p-4 shadow-sm">
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <Form>
              <div className="mb-3">
                {/* <label className="form-label">Description</label> */}
                <ReactQuill
                  theme="snow"
                  value={values.aboutUs}
                  onChange={(content) => setFieldValue("aboutUs", content)}
                  style={{ height: "300px", marginBottom: "40px" }}
                />
                <ErrorMessage
                  name="aboutUs"
                  component="div"
                  className="text-danger mt-2"
                />
              </div>

              <div className="text-end mt-10">
                <Button
                  type="submit"
                  style={{ backgroundColor: "#FFE4E7", color: "black", border: "none" }}
                  disabled={isSubmitting}
                >
                  {isSubmitting
                    ? "Saving..."
                    : isEditMode
                      ? "Update"
                      : "Create"}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AboutForm;
